import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export default lazyLoadComponentFactory(() => import(/* webpackChunkName: "Shared_WebViewNavigation" */ "./WebViewNavigation"));
